import {
  required,
  minLength,
  maxLength,
  email,
  string,
  number,
} from '@regle/rules';
import { createRule } from '@regle/core';

// Reuseable rules:
export const accepted = createRule({
  type: 'accepted',
  validator: (v: unknown) =>
    v === true || v === 'true' || v === 1 || v === '1' || v === 'on',
  message: 'You must accept this field!',
});

// Schemas for common fields:

export const emailSchema = {
  required,
  email,
};

export const fullNameSchema = {
  required,
  string,
  minLength: minLength(2),
  maxLength: maxLength(20),
};

export const ageSchema = {
  required,
  number,
};

export const tosSchema = {
  accepted,
};

export const countrySchema = {
  required,
};

/*
... MORE SCHEMA IF NEEDED ...
 */
